import React, { useState, useRef } from 'react'
import * as styles from './NewPasswordForm.css'
import { signInExternalHost } from '../ExternalHosts'
import { signIn } from '../Auth'
import LoadingBar from 'react-top-loading-bar'
import ALERT_TYPES from '../SharedConstants/AlertTypes'
import { BLUELEAF_LOGO_WHITE } from '../SharedConstants/Images'
import MfaForm from './MfaForm'
require('dotenv').config()

export default function NewPasswordForm (props) {
  const { cognitoUser, sessionUserAttributes } = props
  const [password, setPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [confirmation, setConfirmation] = useState('')
  const [alertType, setAlertType] = useState('')
  const [showMfaForm, setShowMfaForm] = useState(false)
  const [session, setSession] = useState('')
  const [destination, setDestination] = useState('')
  const loadingRef = useRef(null)

  const handleSubmit = (e) => {
    e.preventDefault()

    if (password !== confirmation) {
      setAlertType(ALERT_TYPES.UPDATE_FAILED)
      setErrorMessage('Password and password confirmation do not match')
      return false
    }

    if (password.trim().length === 0) {
      setAlertType(ALERT_TYPES.UPDATE_FAILED)
      setErrorMessage('Please enter your password')
      return false
    }

    loadingRef.current.continuousStart()

    // Make sure these attributes not submitted along with the password reset request, otherwise
    // it will return an error.
    delete sessionUserAttributes.phone_number
    delete sessionUserAttributes.phone_number_verified

    cognitoUser.completeNewPasswordChallenge(password, sessionUserAttributes, {
      onSuccess: (tokens) => {
        signIn(tokens)
        signInExternalHost().then(() => {
          loadingRef.current.complete()
        })
      },
      mfaRequired: function (codeDeliveryDetails, params) {
        setSession(cognitoUser)
        setDestination(params.CODE_DELIVERY_DESTINATION)
        setShowMfaForm(true)
      },
      onFailure: (err) => {
        loadingRef.current.complete()
        setAlertType(ALERT_TYPES.UPDATE_FAILED)
        setErrorMessage(err.message)
      }
    })
  }

  const renderAlert = () => {
    if (alertType === ALERT_TYPES.UPDATE_FAILED) {
      return (
        <div className={styles.alert}>
          { errorMessage }
        </div>
      )
    }
  }

  if (showMfaForm) {
    return <MfaForm
      cognitoUser={ session }
      destination={ destination } />
  } else {
    return (
      <div className={styles.wrapper}>
        <LoadingBar color='#ffffff' ref={loadingRef} />
        <div className={styles.decorativeCircleTop}></div>
        <div className={styles.decorativeCircleBottom}></div>

        <div className={styles.mainContent}>
          <div className={styles.formWrapper}>
            <div className={styles.logoContainer}>
              <img
                alt="Blueleaf"
                src={ BLUELEAF_LOGO_WHITE }
                className={styles.logo}
              />
            </div>

            <div className={styles.formCard}>
              { renderAlert() }

              <div className={styles.formHeader}>
                <h2 className={styles.title}>Set your new password</h2>
                <p className={styles.subtitle}>Please choose a strong password</p>
              </div>

              <form id="new-password-form" onSubmit={handleSubmit}>
                <div className={styles.fieldGroup}>
                  <label className={styles.label}>
                    Password
                  </label>
                  <input
                    className={styles.input}
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your new password"
                  />
                </div>

                <div className={styles.fieldGroup}>
                  <label className={styles.label}>
                    Confirm your new password
                  </label>
                  <input
                    className={styles.input}
                    type="password"
                    value={confirmation}
                    onChange={(e) => setConfirmation(e.target.value)}
                    placeholder="Re-enter your password"
                  />
                </div>

                <input
                  id="submit-btn"
                  className={styles.submitButton}
                  type="submit"
                  value="Set Password"
                />
                <a
                  id="sign-in-btn"
                  className={styles.backToSignIn}
                  href="/"
                >
                  Back to sign in
                </a>
              </form>
            </div>

            <div className={styles.supportContainer}>
              <span className={styles.supportText}>
                Need help? <a href="mailto:vipsupport@blueleaf.com" className={styles.supportLink}>
                  Contact support
                </a>
              </span>
            </div>
          </div>
        </div>

        <div className={styles.footer}>
          <p className={styles.footerText}>
            © 2010–2026 Blueleaf Wealth, Inc. All rights reserved. Patent pending.
          </p>
        </div>
      </div>
    )
  }
}
